import Header from './components/Header';
import Hero from './components/Hero';
import FeaturesSection from './components/FeaturesSection';
import UpdatesSection from './components/UpdatesSection';
import FaqSection from './components/FaqSection';
import MediaSection from './components/MediaSection';
import AboutSection from './components/AboutSection';
import ContactSection from './components/ContactSection';
import RankingSection from './components/RankingSection';
import CardsSection from './components/CardsSection';
import TopicsSection from './components/TopicsSection';
import IndexSection from './components/IndexSection';
import CommentsSection from './components/CommentsSection';
import AppSection from './components/AppSection';
import CarouselSection from './components/CarouselSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <FeaturesSection />
        <UpdatesSection />
        <FaqSection />
        <MediaSection />
        <AboutSection />
        <ContactSection />
        <RankingSection />
        <CardsSection />
        <TopicsSection />
        <IndexSection />
        <CommentsSection />
        <AppSection />
        <CarouselSection />
      </main>
      <Footer />
    </>
  );
}